export const LS_HAS_ACCEPTED_COOKIES = 'rs:hasAcceptedCookies';
